jQuery(document).ready(function ($) {
    const $subscribe = $('.single-event__subscribe');

    if ($subscribe.length) {
        $(document).on('click', '.single-event__subscribe-button', function (e) {
            e.preventDefault();
            $('html, body').animate({
                scrollTop: $subscribe.offset().top
            }, 300);
        });

        const subscribeTop = $subscribe.offset().top;
        const subscribeBottom = subscribeTop + $subscribe.height();

        $(window).on('scroll', function () {
            const windowTop = $(window).scrollTop()
            const windowBottom = windowTop + $(window).height();

            if (windowBottom > subscribeTop && windowTop < subscribeBottom) {
                $('body').addClass('subscribe-hidden');
            } else {
                $('body').removeClass('subscribe-hidden');
            }
        });
    }
});
